import { render } from "./doel-step.vue?vue&type=template&id=3496931a"
import script from "./doel-step.vue?vue&type=script&lang=js"
export * from "./doel-step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__